var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-suppliers',{attrs:{"title":"Formularios de Proveedores","showActionCreate":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }